import { render, staticRenderFns } from "./MachinesCategories.vue?vue&type=template&id=55e6bafa&lang=pug&"
import script from "./MachinesCategories.vue?vue&type=script&lang=ts&"
export * from "./MachinesCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports